import { Inject, Injectable, DOCUMENT } from '@angular/core';

import { animate, AnimationBuilder, AnimationPlayer, style } from '@angular/animations';
import { NavigationEnd, Router } from '@angular/router';

import { filter, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FuseSplashScreenService
{
    splashScreenEl: any;
    player: AnimationPlayer;
    private isHidden: boolean = false;
    private fallbackTimeout: any;

    /**
     * Constructor
     *
     * @param {AnimationBuilder} animationBuilder
     * @param document
     * @param {Router} router
     */
    constructor(
        private animationBuilder: AnimationBuilder,
        @Inject(DOCUMENT) private document: any,
        private router: Router
    )
    {
    console.log("in constructor of splash-screen.service.ts file ");
        // Initialize
        this.init();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Initialize
     *
     * @private
     */
    private init(): void
    {
    console.log("in init() method of splash-screen.service.ts file ");
        // Get the splash screen element
        this.splashScreenEl = this.document.body.querySelector('#fuse-splash-screen');

        // If the splash screen element exists...
        if ( this.splashScreenEl )
        {
        console.log("in init()::if block method of splash-screen.service.ts file ");
            this.fallbackTimeout = setTimeout(() => {
                if (!this.isHidden) {
                    this.hide();
                }
            }, 10000);

            if (this.router.url && this.router.url !== '/') {
                setTimeout(() => {
                    if (!this.isHidden) {
                        this.hide();
                    }
                }, 500);
            }
            // Hide it on the first NavigationEnd event
            this.router.events
                .pipe(
                    filter((event => event instanceof NavigationEnd)),
                    take(1)
                )
                .subscribe(() => {
                console.log("in init()::subscribe method of splash-screen.service.ts file ");
                    if (this.fallbackTimeout) {
                        clearTimeout(this.fallbackTimeout);
                    }
                    setTimeout(() => {
                        if (!this.isHidden) {
                        this.hide();
                        }
                    }, 100);
                });
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Show the splash screen
     */
    show(): void
    {
    console.log("in show() method of splash-screen.service.ts file ");
        this.player =
            this.animationBuilder
                .build([
                    style({
                        opacity: '0',
                        zIndex : '99999'
                    }),
                    animate('400ms ease', style({opacity: '1'}))
                ]).create(this.splashScreenEl);

        setTimeout(() => {
            this.player.play();
        }, 0);
    }

    /**
     * Hide the splash screen
     */
    hide(): void
    {
        if (this.isHidden || !this.splashScreenEl) {
            return;
        }
    console.log("in hide() method of splash-screen.service.ts file ");
        this.isHidden = true;
        if (this.fallbackTimeout) {
            clearTimeout(this.fallbackTimeout);
            this.fallbackTimeout = null;
        }
        this.player =
            this.animationBuilder
                .build([
                    style({opacity: '1'}),
                    animate('400ms ease', style({
                        opacity: '0',
                        zIndex : '-10'
                    }))
                ]).create(this.splashScreenEl);

        setTimeout(() => {
            this.player.play();
        }, 0);
    }
}
